import type { Logo } from "../types";

export type LogoVariant = keyof Logo;

export const resolveAppLogoSource = (
	logo: Logo,
	variant: LogoVariant,
	isDarkTheme: boolean,
	inverse = false,
) => {
	const logoVariant = logo[variant];
	const useDarkLogo = inverse ? !isDarkTheme : isDarkTheme;
	return useDarkLogo ? logoVariant.dark : logoVariant.light;
};
